export default __webpack_public_path__ + "static/real-3a391575a3d95af8c47055ac53ade0d9.svg";